export default "__VITE_ASSET__BmmqS7dW__"